import { Controller } from "@hotwired/stimulus"

// Stimulus controller for testing API connection
export default class extends Controller {
  static targets = ["message"]
  static values = { url: String }

  async test(event) {
    event.preventDefault()
    console.log("Connection test started")
    console.log("URL:", this.urlValue)

    const button = event.currentTarget
    const originalText = button.innerHTML

    // Show loading state
    button.disabled = true
    button.innerHTML = `
      <svg class="animate-spin -ml-1 mr-2 h-5 w-5 inline" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Testing...
    `

    try {
      console.log("Sending POST request...")
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken
        }
      })

      console.log("Response status:", response.status)
      const data = await response.json()
      console.log("Response data:", data)

      if (data.success) {
        this.showMessage(data.message, "success")
      } else {
        this.showMessage(data.message, "error")
      }
    } catch (error) {
      console.error("Connection test error:", error)
      this.showMessage(`Failed to test connection: ${error.message}`, "error")
    } finally {
      // Restore button state
      button.disabled = false
      button.innerHTML = originalText
      console.log("Connection test completed")
    }
  }

  showMessage(message, type) {
    const bgColor = type === "success" ? "bg-green-50 dark:bg-green-900/20" : "bg-red-50 dark:bg-red-900/20"
    const textColor = type === "success" ? "text-green-800 dark:text-green-200" : "text-red-800 dark:text-red-200"
    const iconColor = type === "success" ? "text-green-600 dark:text-green-400" : "text-red-600 dark:text-red-400"
    const icon = type === "success"
      ? `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>`
      : `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>`

    this.messageTarget.innerHTML = `
      <div class="rounded-md ${bgColor} p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 ${iconColor}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              ${icon}
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium ${textColor}">${message}</p>
          </div>
        </div>
      </div>
    `

    // Auto-hide after 5 seconds
    setTimeout(() => {
      this.messageTarget.innerHTML = ""
    }, 5000)
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
